const locationTypes = Object.freeze({
  geo: 0,
  iBeacon: 2
})

const locationLabels = Object.freeze({
  0: 'CampaignForm_Locations_Type_GeoFence',
  2: 'CampaignForm_Locations_Type_IBeacon'
})

export { locationTypes, locationLabels }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/components/locations/locationsEnum.js